import dayjs from "dayjs";

import { formatIdentifier } from "@/utils/formatIdentifier";
import { phoneFormat } from "@/utils/formatPhone";
import { addressConcat } from "@/utils/adreessConcat";
import { DetailedCitizenAttendancesIndicatorC3Data } from "@/services/esus/indicator/esf/c3/getDetailedCitizensAttendancesIndicatorC3";

import { TimeLine, TimeLineContent } from "@/components/TimeLine";
import { IndicatorEsfC3CitizenAttendancesHistoryItem } from "./IndicatorEsfC3CitizenAttendancesHistoryItem";
import { IndicatorEsfC3CitizenAttendancesHistoryInfo } from "./IndicatorEsfC3CitizenAttendancesHistoryInfo";
import { IndicatorEsfC3CitizenDentalAttendancesHistoryItem } from "./IndicatorEsfC3CitizenDentalAttendancesHistoryItem";

type IndicatorEsfC3CitizenAttendancesHistoryProps = {
	citizenWithAttendances: DetailedCitizenAttendancesIndicatorC3Data;
};

export function IndicatorEsfC3CitizenAttendancesHistory({
	citizenWithAttendances,
}: Readonly<IndicatorEsfC3CitizenAttendancesHistoryProps>) {
	const indicatorEsfC1CitizenHistoryInfo = {
		fullName: citizenWithAttendances.fullName ? citizenWithAttendances.fullName : "N/A",
		birthdate: citizenWithAttendances.birthdate
			? dayjs(citizenWithAttendances.birthdate).format("DD/MM/YYYY")
			: "N/A",
		document: citizenWithAttendances.cpf
			? formatIdentifier(citizenWithAttendances.cpf)
			: citizenWithAttendances.cns ?? "",
		motherName: citizenWithAttendances.motherName ?? "",
		phone: citizenWithAttendances.phone ? phoneFormat(citizenWithAttendances.phone) : "",
		address:
			addressConcat(
				citizenWithAttendances.street,
				citizenWithAttendances.houseNumber,
				citizenWithAttendances.neighborhood
			) ?? "",
	};

	return (
		<>
			<IndicatorEsfC3CitizenAttendancesHistoryInfo {...indicatorEsfC1CitizenHistoryInfo} />
			<TimeLine
				timeLineTitle="Consultas - Puerpério"
				timeLineContents={(citizenWithAttendances.puerperalAttendance
					? [citizenWithAttendances.puerperalAttendance]
					: []
				).map<TimeLineContent>((attendance) => {
					return {
						content: (
							<IndicatorEsfC3CitizenAttendancesHistoryItem attendance={attendance} />
						),
						eventDate: attendance.date
							? dayjs(attendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Consultas"
				timeLineContents={(
					citizenWithAttendances.pregnancyAttendances ?? []
				).map<TimeLineContent>((attendance) => {
					return {
						content: (
							<IndicatorEsfC3CitizenAttendancesHistoryItem attendance={attendance} />
						),
						eventDate: attendance.date
							? dayjs(attendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Aferições de PA"
				timeLineContents={(
					citizenWithAttendances.bloodPressureMeasurements ?? []
				).map<TimeLineContent>((bloodPressureMeasurement) => {
					return {
						content: (
							<IndicatorEsfC3CitizenAttendancesHistoryItem
								attendance={bloodPressureMeasurement}
							/>
						),
						eventDate: bloodPressureMeasurement.date
							? dayjs(bloodPressureMeasurement.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Registros de Peso e Altura"
				timeLineContents={(
					citizenWithAttendances.weightAndHeightMetricsRegisters ?? []
				).map<TimeLineContent>((metricsAttendance) => {
					return {
						content: (
							<IndicatorEsfC3CitizenAttendancesHistoryItem
								attendance={metricsAttendance}
							/>
						),
						eventDate: metricsAttendance.date
							? dayjs(metricsAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
			<TimeLine
				timeLineTitle="Consultas Odontológicas"
				timeLineContents={(
					citizenWithAttendances.dentalAttendances ?? []
				).map<TimeLineContent>((dentalAttendance) => {
					return {
						content: (
							<IndicatorEsfC3CitizenDentalAttendancesHistoryItem
								dentalAttendance={dentalAttendance}
							/>
						),
						eventDate: dentalAttendance.date
							? dayjs(dentalAttendance.date).format("DD/MM/YYYY")
							: "N/A",
					};
				})}
			/>
		</>
	);
}
